import { render, staticRenderFns } from "./showing-site-detail.vue?vue&type=template&id=5c10a752&scoped=true&"
import script from "./showing-site-detail.vue?vue&type=script&lang=js&"
export * from "./showing-site-detail.vue?vue&type=script&lang=js&"
import style0 from "./showing-site-detail.vue?vue&type=style&index=0&id=5c10a752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10a752",
  null
  
)

export default component.exports